// import { createReducer } from "./functions";
import { SET_CURRENT_USER_INFOS } from "./../types";

export default (state = {}, action) => {
	switch (action.type) {
		case SET_CURRENT_USER_INFOS:
			return action.payload;
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// src/redux/reducers/userInfosReducer.js